import { useCallback, useContext } from "react";

import { Icon, Item, Listbox, Span } from "@icg360/design-system";

import { AddPolicy } from "components/add-policy";
import { AuthAppContext } from "components/root/auth-app-provider";

import styles from "./mobile-policy-selector.module.scss";

type MobilePolicySelectorProps = {
  onClose: () => void;
};

export const MobilePolicySelector = ({
  onClose,
}: MobilePolicySelectorProps) => {
  const { policies, selectedPolicyId } = useContext(AuthAppContext);

  const onSelectionChange = useCallback(
    (selection: Set<string>) => {
      onClose();
      const selectedPolicyId = selection.keys().next().value;
      const selectedPolicy = policies?.find(
        ({ policyId }) => policyId === selectedPolicyId
      );
      if (selectedPolicy) {
        const policyUrl = new URL(window.location.href);
        policyUrl.searchParams.set("policyId", selectedPolicy.insightPolicyId);
        window.location.assign(policyUrl);
      }
    },
    [onClose, policies]
  );

  return policies ? (
    <div className={styles.policySelector}>
      <Listbox
        selectedKeys={new Set([selectedPolicyId])}
        selectionMode="single"
        onSelectionChange={onSelectionChange}
        className={styles.selectorBoxDS}
        aria-label="policies"
      >
        {policies.map((policy) => {
          const { propertyAddress, policyId, isCommercial } = policy ?? {};
          const selected = policyId === selectedPolicyId;
          return (
            <Item
              key={policyId}
              textValue={`${propertyAddress?.street1} ${propertyAddress?.street2} policy number ${policyId}`}
            >
              <div className={styles.policy}>
                <Icon name={isCommercial ? "Store" : "Home"} />
                <div className={styles.address}>
                  <Span color={selected ? "inverse" : "default"} bold>
                    {propertyAddress?.street1}
                  </Span>
                  {propertyAddress?.street2 ? (
                    <Span color={selected ? "inverse" : "default"} bold>
                      {propertyAddress?.street2}
                    </Span>
                  ) : null}
                  {`(Policy #${policyId})`}
                </div>
              </div>
            </Item>
          );
        })}
      </Listbox>
      <div className={styles.addPolicyLink}>
        <AddPolicy />
      </div>
    </div>
  ) : null;
};
